import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'
import { useSearchStateContext } from './useSearchState'

const NotFound = () => {
  const context = useSearchStateContext()
  const { search } = context

  return (
    <StyledWrapper>
      <div className="notfound-title">
        <p>
          {search.organizationName ? `'${search.organizationName}' ` : null}
          {search.role ? `'${search.role}' ` : null}
          {search.keyword ? `'${search.keyword}'` : null}
          <span>에 대한 검색결과가 없습니다.</span>
        </p>
      </div>
      <p>
        단어의 철자가 정확한지 확인하세요. <br />
        다른 검색어를 사용해보세요. <br />더 일반적인 검색어를 사용해보세요.
      </p>
    </StyledWrapper>
  )
}

export default NotFound

const StyledWrapper = styled.div`
  text-align: center;
  padding-top: 40px;
  border-bottom: 0.5px solid #eeeeee;
  padding-bottom: 40px;

  .notfound-title {
    display: flex;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: -0.8px;
    > p {
      color: #01a0ff;
      > span {
        font-size: 20;
        font-weight: 'bold';
        letter-spacing: '-0.8px';
        ${mobileBreakPoint} {
          width: 250px;
        }
        color: #333333;
      }
    }
  }

  > p {
    margin-top: 10px;
    font-size: 16px;
    color: #999999;
    font-weight: 500;
  }
`
